import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const ArrowRightIcon: React.FunctionComponent<IconProps> = ({
  width = 8,
  height = 12,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={8} viewBoxHeight={12} {...rest}>
    <path d="M0.501666 1.49029L4.82722 6.04549L0.501666 10.6007L1.83333 12L7.5 6.04549L1.83333 0.0909786L0.501666 1.49029Z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/ui/icon/arrow-right.icon.tsx